document.addEventListener('click', (event) => {
  const btn = event.target.closest('[data-coupon-copy]');
  if (!btn) return;

  const code = btn.getAttribute('data-coupon-copy');
  if (!code) return;

  const label = btn.querySelector('.product-coupon__btn-label') || btn;
  const original = label.textContent;
  const markCopied = () => {
    label.textContent = 'COPIED';
    window.setTimeout(() => {
      label.textContent = original;
    }, 1600);
  };

  const fallbackCopy = () => {
    const input = document.createElement('textarea');
    input.value = code;
    input.setAttribute('readonly', '');
    input.style.position = 'absolute';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
    markCopied();
  };

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(markCopied).catch(fallbackCopy);
  } else {
    fallbackCopy();
  }
});
